const reactToPrintModalQRCode = {
  btnLabel: 'imprimir'
};

export default reactToPrintModalQRCode;
